import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  getCampaignDetailsDiscountLabel,
  getCampaignDetailsExpirationLabel,
  getCampaignDetailsStatusLabel,
  getCampaignTypeLabel
} from '@/ducks/campaigns/campaigns.helpers'
import type { Campaign } from '@/ducks/campaigns/campaigns.types'

import Styles from './CampaignDetailsModal.module.scss'

type Props = {
  campaign: Campaign
  discountValue?: string
  expirationValue?: string
}

const SummaryField = ({
  label,
  value
}: {
  label: string
  value: string
}) => (
  <div className={Styles.field}>
    <span className={Styles.fieldLabel}>{label}</span>
    <span className={Styles.fieldValue}>{value}</span>
  </div>
)

const CampaignDetailsSummary = ({
  campaign,
  discountValue,
  expirationValue
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={Styles.summaryGrid}>
      <SummaryField
        label={t('marketing.campaigns.details.offer-type')}
        value={getCampaignTypeLabel(campaign.campaignType, t)}
      />
      <SummaryField
        label={t('marketing.campaigns.details.status')}
        value={getCampaignDetailsStatusLabel(campaign, t)}
      />
      <SummaryField
        label={t('marketing.campaigns.details.discount-value')}
        value={discountValue ?? getCampaignDetailsDiscountLabel(campaign, t)}
      />
      <SummaryField
        label={t('marketing.campaigns.details.expire-in')}
        value={
          expirationValue ?? getCampaignDetailsExpirationLabel(campaign, t)
        }
      />
    </div>
  )
}

export default CampaignDetailsSummary
